var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10zM9.462 10.96H3.538a.5.5 0 0 0-.491.41l-.009.09v.04a.5.5 0 0 0 .41.492l.09.008h5.924a.5.5 0 0 0 .491-.41l.009-.09v-.04a.5.5 0 0 0-.5-.5zm.523-5.489-.062.037-3.562 2.799-.073.065-.064.073A.815.815 0 0 0 7.43 9.533l.074-.082L10.3 5.885l.035-.06a.27.27 0 0 0 .006-.199l-.033-.061-.008-.012-.052-.05a.268.268 0 0 0-.263-.032zm.445 1.838-.707.901c.133.334.217.693.241 1.068l.007.227H11c0-.798-.207-1.547-.57-2.196zM6.5 5a4.502 4.502 0 0 0-4.495 4.293L2 9.505h1.029A3.473 3.473 0 0 1 7.37 6.14l.206.06.93-.728A4.477 4.477 0 0 0 6.5 5zm4.889-4h-.778a.167.167 0 0 0-.167.167v1.277H9.167A.167.167 0 0 0 9 2.611v.778c0 .092.075.167.167.167h1.277v1.277c0 .092.075.167.167.167h.778a.167.167 0 0 0 .167-.167V3.556h1.277A.167.167 0 0 0 13 3.389V2.61a.167.167 0 0 0-.167-.167h-1.277V1.167A.167.167 0 0 0 11.389 1z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToDashboard);
export default __webpack_public_path__ + "static/media/add-to-dashboard.3cb1aa92a13ac562d46204bfd3fc2f2b.svg";
export { ForwardRef as ReactComponent };